/**
 * Class with methods to help with comparison of objects
 */
export class ComparisonHelper {

    /**
     * Compares two arrays based on the property specified
     *
     * @param thisObjectsProperty array belonging to this object that will be compared
     * @param otherObjectsProperty array belonging to another object that will be compared
     * @param propertyToCompareOn the property to compare the objects on
     *
     * @returns boolean - true if objects are equal
     */
    public compareObjectsArraysForEquality(thisObjectsProperty: any, otherObjectsProperty: any, propertyToCompareOn?: string): boolean {
        let thisSimpleObjectArray = thisObjectsProperty;
        let otherSimpleObjectArray = otherObjectsProperty;

        if (thisSimpleObjectArray === null && otherSimpleObjectArray === null) {
            return true;
        }
        if (thisSimpleObjectArray === null || otherSimpleObjectArray === null) {
            return false;
        }
        if (propertyToCompareOn) {
            thisSimpleObjectArray = thisObjectsProperty?.map(object => object[propertyToCompareOn]);
            otherSimpleObjectArray = otherObjectsProperty?.map(object => object[propertyToCompareOn]);
        }
        for (let i = 0; i < thisSimpleObjectArray?.length; i++) {
            if (!otherSimpleObjectArray?.includes(thisSimpleObjectArray[i])) {
                return false;
            }
        }

        return thisSimpleObjectArray?.length === otherSimpleObjectArray?.length;
    }
}

/* eslint-disable @typescript-eslint/naming-convention */
export const StaticComparisonHelper = new ComparisonHelper();
